import { memo, useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useGTMEvent } from 'hooks/UseGTM';
import useGoToRoute from 'hooks/GoToRoute';
import useQueryParams from 'hooks/UseQueryParams';
// Import UI components
import { Tooltip } from '@geneui/components';
// Import Constants
import { GACategoryEvents } from 'constants/common';

interface Props {
    path?: { name: string; params?: object } | string;
    name: string;
    queryParams?: Record<string, unknown>;
    isClickable?: boolean;
    tooltipConfig?: object;
}

const { GADetailsCategory } = GACategoryEvents;

const TittleLink: React.FC<Props> = (props) => {
    const { path, name, queryParams, isClickable = true, tooltipConfig = { position: 'bottom' } } = props;
    const { goToRoute, getRoutePath } = useGoToRoute();
    const { search } = useLocation();
    const { logEvent } = useGTMEvent();
    const goToRouteQueryParams = useQueryParams();

    const buttonOnClick = useCallback(
        (e) => {
            e.preventDefault();
            logEvent(
                GADetailsCategory.name,
                GADetailsCategory.events[`${(path as { name: string }).name}TitleDetails`],
                GADetailsCategory.labels.titleDetails,
                1,
            );
            goToRoute(path, queryParams, goToRouteQueryParams.encode({ backParams: search }));
        },
        [goToRoute, logEvent, path, queryParams, goToRouteQueryParams, search],
    );

    const link = useMemo(
        () => (isClickable ? getRoutePath(path, queryParams, null) : null),
        [getRoutePath, path, queryParams, isClickable],
    );

    return (
        <Tooltip text={name} {...tooltipConfig}>
            {isClickable ? (
                <a className="tittle-text ellipsis-text" onClick={buttonOnClick} href={link || undefined}>
                    {name}
                </a>
            ) : (
                <span className="ellipsis-text">{name}</span>
            )}
        </Tooltip>
    );
};

export default memo(TittleLink);
